import React, { Dispatch, SetStateAction } from "react";
import { createContext, useContext, useState, ReactNode } from "react";

type ContextProviderProps = {
  children?: ReactNode
}

interface LoadingContextType {
  loading: boolean,
  setLoading: Dispatch<SetStateAction<boolean>>;
}

export const LoadingContext = createContext<LoadingContextType>({
  loading: false,
  setLoading: () => {}
})


export const LoadingProvider = ({children}: ContextProviderProps) => {
  const [loading, setLoading] = useState<boolean>(false)

  return (
      <LoadingContext.Provider value={{loading, setLoading}}>{children}</LoadingContext.Provider>
  );
}

export function useLoading() {
  const context = useContext(LoadingContext);

  if (!context) {
    throw new Error("useLoading must be used within LoadingProvider");
  }
  return context;
}



